
/**
 * @fileOverview GSN Controller
 * Last Modified: 3/24/2020
 */


(function (context) {
    'use strict';

    var require = context.require
    var requirejs = context.requirejs;
    var define = context.define;
    define("apps/gsn/controller", ['require', 'jquery', 'lib/Util', 'GlobalEventDispatcher', 'GlobalResizeListener'], function (require, $, util, GlobalEventDispatcher, GlobalResizeListener) {

        var newGSN = function (options) {
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            this.init();
        };

        var prevSize = $(window).width();
        newGSN.prototype.init = function () {
            this.context = this.globalResizeListener.currentContext;
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE,
                function () {
                    if (this.globalResizeListener.currentContext !== this.context) {
                        const currentSize = $(window).width();
                        if ($('.is-navbar_link.is-active').length > 0 || $('.m-header_menuLink.is-open').length > 0) {
                            if (currentSize < 960 && prevSize > 959) {  //Desktop to Mobile
                                resetDesktopMenuOverlay();
                            }
                            if (currentSize > 959 && prevSize < 960) {  // Mobile to Desktop
                                resetMobileMenu();
                            }
                        }
                        this.context = this.globalResizeListener.currentContext;
                        prevSize = currentSize;
                        modalAccessibilityTrigger();
                        expheadingAccessibilityTrigger();
                    }
                    
                    if ($(window).width() > 959) {  //D,L
                        $("div.myLinkl1").next().css("display", "block");
                        $("div.myAccountl1").next().css("display", "block");
                        $(".mad-myLinks").show();
                        $(".mad-myAccount").show();
                        $(".myLinkl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                        $(".myAccountl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                        $(".MyLogOutl1").hide();
                    }else if ($(window).width() < 960) {  //M,T
                        $(".mad-myLinks").show();
                        $(".mad-myAccount").show();
                        $(".myLinkl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                        $(".myAccountl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                        $("div.myAccountl1").next().css("display", "none");
                        $("div.myLinkl1").next().css("display", "none");
                        $(".mad-nav-arrow").removeClass('MMM--icn_lt2').addClass('MMM--icn_gt2');
                        $(".mad-nav-icn").show();
                        $(".MyLogOutl1").show();
                    }
                }.bind(this));

                this.detectListType();
                this.setupHandlers();
        }

        newGSN.prototype.detectListType = function () {
            $('.l-dropdown-list_container').each(function()  {
                // Add product class if no image is found
                if ($(this).find('img').length === 0) {
                    $(this).addClass('l-dropdown-list--products');
                }
                // Add brand class name if logo container exists
                else if ($(this).find('.l-dropdown-logo_container').length > 0) {
                    $(this).addClass('l-dropdown-list--brands');
                } 
                // Add industries class name if more than one image exists in container
                else if ($(this).find('img').length > 0) {
                    $(this).addClass('l-dropdown-list--industries');
                }
            })
            return null;
        }
        // --------------- Event Listeners ---------------
        newGSN.prototype.setupHandlers = function () {
            ellipsisTrigger();

            modalAccessibilityTrigger();
            
            expheadingAccessibilityTrigger();

            $('.is-header_menuLink, .is-overlay').on("click", menuLinkHandler);

            $('.m-dropdown-list_overlay').click(function () {
                resetDesktopMenuOverlay();
            });

            var returnToMainMenu = true;
            var escapeHandled = false;
            $('.l-dropdown-list_container').keyup(function(e){
                if(e.key === 'Escape' && !escapeHandled){
                    resetDesktopMenuOverlay();
                    var navTab = e.target.parentElement.parentElement;
                    if(navTab.id === "products-list"){
                        $('#navOptions a.is-navbar_link').first().focus();
                    }else if(navTab.id === "industries-list"){
                        $('#navOptions a.is-navbar_link').focus();
                    }
                } else escapeHandled = false
            });

            // Menu Items Heading Links
            $('.is-navbar_link').click(function (e) {
                e.preventDefault();
                var self = this;
                var isOnDesktop = false;
                var active = $('.is-navbar_link').hasClass('is-active');
                var activeItem = $('.is-navbar_link.is-active');

                $('.is-navbar_link').removeClass('is-active');
                resetAriaAttr($('.is-navbar_link'), 'aria-expanded');
                $('.l-dropdown-list_container').attr('aria-hidden', "true");

                if ($(window).width() > 959) {
                    isOnDesktop = true;
                }

                if (active) {
                    if (activeItem.text() !== $(self).text()) {
                        $(self).toggleClass('is-active');
                        ariaToggle($(self), 'aria-expanded');
                        if (isOnDesktop) {
                            $('.js-navbar_level-2').toggle();
                        }
                    } else {
                        $('.m-dropdown-list_overlay').hide();
                    }
                }
                if (!active) {
                    if (isOnDesktop) {
                        $('.m-dropdown-list_overlay').show();
                    }
                    $(self).toggleClass('is-active');
                    ariaToggle($(self), 'aria-expanded');

                }

                resetDropdownLists();

                if (isOnDesktop) {
                    $('.js-navbar_level-2').toggle();
                }
                else {
                    openAndCloseDropdownList();
                }

                // Toggle the associated GSN list based on the id naming convention
                var thisId = self.id;
                var thisTab = thisId.replace('navbar_link-', '')
                if (thisTab && thisTab !== thisId) {
                    if (!isOnDesktop) {
                        $('#dropdown-list_' + thisTab + '-title').show();
                    }
                    const associatedList = $('#' + thisTab + '-list');
                    associatedList.show();
                    if (!associatedList.is(':hidden')) {
                        ariaToggle(associatedList, 'aria-hidden');
                        focusFirstDropdownItem(associatedList);
                    }
                }
            });

            $('.js-dropdown-list_backBtn').click(function () {
                if(returnToMainMenu){
                    openAndCloseDropdownList();
                    resetDropdownLists();
                    $('.is-navbar_link').removeClass('is-active');
                    resetAriaAttr($('.is-navbar_link'), 'aria-expanded');
                    $('.l-dropdown-list_container').attr('aria-hidden', "true");
                } else {
                    const newTitle = $('#navbar_link-industries').text()
                    $('#dropdown-list_industries-title').text(newTitle);
                    $('.l2-dropdown-list_container').css('display', 'none');
                    $('.l-dropdown-list_content--industries').css('display', 'block');
                    returnToMainMenu = true;

                }

            });

            $('.js-backtoTopBtn').click(function () {
                $(".l-dropdown-list_container").animate({
                    scrollTop: 0
                }, 1000);
            });

            $('.is-searchbar').focusin(function (e) {
                e.preventDefault();
                $('.m-header').addClass('is-searching');
                
                var isTAenabled = false;
                if( window.SETTINGS.esTypeAhead ){
                    isTAenabled = window.SETTINGS.esTypeAhead.enabled;
                }

                if( isTAenabled ){
                    resetDesktopMenuOverlay();
                    $('.is-dropdown').addClass('h-hidden');
                }
            });

            $('.is-searchbar').focusout(function (e) {
                e.preventDefault();
                $('.m-header').removeClass('is-searching');
            });

            $('.is-localeToggle, .is-localePopUp .is-close').on('click', function (e) {
                e.preventDefault();
                localeModalToggle();
            });

            $('.is-signInToggle, .is-signInPopUp .is-close').on('click', function (e) {
                e.preventDefault();
                signInModalToggle();
            });
            
            $('.is-signInPopUp').on('keydown', function (e) {
                if(e.key === 'Escape'){
                    signInModalToggle();
                }
            });

            $('.is-profileToggle, .is-profilePopUp .is-close').on('click', function (e) {
                e.preventDefault();
                profileModalToggle();
            });

            $('.mad-menu-container a').on('click', function (e) {
                profileModalToggle();
            });

            $('.is-saveLocale').on('click', function (e) {
                e.preventDefault();
                var urlPath = $('input[type=radio][name=locale]:checked').val();
                if (urlPath.indexOf('://') > 0 || urlPath.indexOf('//') === 0 ) {
                    // URL is absolute; either "http://example.com" or "//example.com"
                    window.open(urlPath, '_self');
                } else {
                    // URL is relative
                    window.open(window.origin + urlPath, '_self');
                }
            })

            $('.m-nav a, .m-nav li').mouseover(function () {
                var isTAenabled = false
                if(window.SETTINGS.esTypeAhead){
                    isTAenabled = window.SETTINGS.esTypeAhead.enabled;
                }

                if(isTAenabled) return;
                document.activeElement.blur();
            });

        //MAD Logic 2020   
        $('.myLinkl1').click(function () {
            if ($(document).width() < 960) {
                if ($(".myLinkl1").hasClass("myLinkTitlel2")) {
                    //@lvl2
                    $(".myLinkl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                    $(".mad-nav-icn").show();
                    $(".mad-myAccount").show();
                    $(".MyLogOutl1").show();
                    $(".mad-nav-arrow").removeClass('MMM--icn_lt2').addClass('MMM--icn_gt2');
                    $("div.myLinkl1").next().css("display", "none");
                }else{
                    //@lvl1
                    $(".myLinkl1").addClass("myLinkTitlel2").parent().addClass("myTitleBox");
                    $(".mad-nav-icn").hide();
                    $(".mad-myAccount").hide();
                    $(".MyLogOutl1").hide();
                    $(".mad-nav-arrow").removeClass('MMM--icn_gt2').addClass('MMM--icn_lt2');
                    $("div.myLinkl1").next().show();
                }
            }
        });
        
        $('.myAccountl1').click(function () {
            if ($(document).width() < 960) {
                if ($(".myAccountl1").hasClass("myLinkTitlel2")) {
                    //@lvl2
                    $(".myAccountl1").removeClass("myLinkTitlel2").parent().removeClass("myTitleBox");
                    $(".mad-nav-icn").show();
                    $(".mad-myLinks").show();
                    $(".MyLogOutl1").show();
                    $(".mad-nav-arrow").removeClass('MMM--icn_lt2').addClass('MMM--icn_gt2');
                    $("div.myAccountl1").next().hide();
                }else{
                    //@lvl1
                    $(".myAccountl1").addClass("myLinkTitlel2").parent().addClass("myTitleBox");
                    $(".mad-nav-icn").hide();
                    $(".mad-myLinks").hide();
                    $(".MyLogOutl1").hide();
                    $(".mad-nav-arrow").removeClass('MMM--icn_gt2').addClass('MMM--icn_lt2');
                    $("div.myAccountl1").next().show();
                }
            }
        });

        $('.js-menu-link').each(function () {
            const link = $(this);

            link.on('click', function () {
                handleMenuChange(link);
                returnToMainMenu = false;
              });
              
            link.on('focus', function () {
                if ($(window).width() > 959) {
                    handleMenuChange(link);
                }
            });
    
            link.on('keydown', function (event) {
              if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                const sublistId = 'sublist-' + link.attr('id').toLowerCase().replace(/ /g, '-');
                const activeSublist = $('#' + sublistId);
                if (activeSublist.length) {
                  focusFirstDropdownItem(activeSublist); // Focus the first item of the active sublist
                }
              }
              
            });
        });

          $('.js-submenu-link').each(function () {
            const link = $(this);
    
            link.on('keydown', function (event) {
              // Add arrow key navigation
              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                event.preventDefault();
                const sublist = this.closest('.l2-dropdown-list_content');
                const activeSublist = $('#' + sublist.id);
                if (activeSublist.length) {
                  const items = activeSublist.find('a');
                  const currentIndex = items.index(document.activeElement);
                  var nextIndex = currentIndex;
    
                  if (event.key === 'ArrowUp') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                  } else if (event.key === 'ArrowDown') {
                    nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                  }
    
                  items.eq(nextIndex).focus();
                }
              }
    
              if (event.key === 'Escape') {
                event.preventDefault();
                const parentList = $(this).closest('.l2-dropdown-list_content');
                const parentListId = parentList.attr('id');
                const mainLinkId = parentListId.replace('sublist-', '');
                $('#' + mainLinkId).focus();
                escapeHandled = true
              }
            });
          });

        } //// --------------- Closeing Event Listeners --------------- 

        // ----------------- Functions -----------------

        function openAndCloseDropdown() {
            var _self = $('.is-header_menuLink');
            $('.m-header').toggleClass('is-navigating');

            // If drop-down menu is collapsed
            if (_self.hasClass('is-collapsed')) {
                _self.removeClass('is-collapsed').addClass('is-open').attr('aria-expanded', 'true');
                _self.attr('aria-label', _self.data('closelabel'));
                _self.children('.is-header_menuIcon').removeClass('MMM--icn_hamburgerMenu').addClass('MMM--icn_close');
                $('.is-dropdown').removeClass('h-hidden');
                $('.is-header_container').addClass('h-fixed');

                // Prevent scrolling on the content behind (taken from: https://stackoverflow.com/questions/3656592/how-to-programmatically-disable-page-scrolling-with-jquery)
                if ($(window).width() < 960) {
                    $('html, body').css({
                        overflow: 'hidden',
                        height: '100%'
                    });
                }
            } else {
                _self.addClass('is-collapsed').removeClass('is-open').attr('aria-expanded', 'false');
                _self.children('.is-header_menuIcon').addClass('MMM--icn_hamburgerMenu').removeClass('MMM--icn_close');
                _self.attr('aria-label', _self.data('openlabel'));
                $('.is-dropdown').addClass('h-hidden');
                $('.is-header_container').removeClass('h-fixed');

                // Restore scrolling
                $('html, body').css({
                    overflow: 'auto',
                    height: 'auto'
                });
            }
            return true;
        }

        function openAndCloseDropdownList() {
            $('.js-navbar_level-1').toggle();
            $('.js-navbar_level-2').toggle();
        }

        function resetDropdownLists() {
            $('.m-dropdown-list_title label').hide();
            $('.l-dropdown-list_container').hide();
            $('.l2-dropdown-list_container').hide();
        }

        function resetDesktopMenuOverlay() {
            resetDropdownLists();
            $('.is-navbar_link').removeClass('is-active');
            $('.js-navbar_level-2').hide();
            $('.m-dropdown-list_overlay').hide();
            resetAriaAttr($('.is-navbar_link'), 'aria-expanded');
            $('.l-dropdown-list_container').attr('aria-hidden', "true");
        }

        function resetMobileMenu() {
            if ($('.is-navbar_link.is-active').length > 0) {
                openAndCloseDropdownList();
                resetDropdownLists();
                $('.is-navbar_link').removeClass('is-active');
            }
            openAndCloseDropdown();
            resetAriaAttr($('.is-navbar_link'), 'aria-expanded');
            $('.l-dropdown-list_container').attr('aria-hidden', "true");
        }

            // Function to handle title and sublist change
        function handleMenuChange(link) {
            const newTitle = link.attr('aria-label');
            if($(window).width() < 960) {
                $('#dropdown-list_industries-title').text(newTitle);
                $('.l-dropdown-list_content--industries').css('display', 'none');
            }
            else {
                $('#marketTitle').text(newTitle);
            }
            $('.l2-dropdown-list_container').css('display', 'block');
  
            const sublistId = 'sublist-' + link.attr('id').toLowerCase().replace(/ /g, '-');
            $('.l2-dropdown-list_content').hide();
            const activeSublist = $('#' + sublistId);
            if (activeSublist.length) {
                activeSublist.show();
            }
  
            const isExpanded = link.attr('aria-expanded') === 'true';
            link.attr('aria-expanded', !isExpanded);
        }

        // Event Controller for the Dropdown
        var menuLinkHandler = function (e) {
            e.preventDefault();
            openAndCloseDropdown();
        };

        var localeModalToggle = function () {
            $('.is-localePopUp').toggleClass('h-hidden');
            if ($('.is-localePopUp').hasClass('h-hidden')) {
                $('.is-localeToggle').focus();
            } else {
                if ($(window).width() > 959) {
                    resetDesktopMenuOverlay();
                    $('.is-localePopUp input').focus();
                } else {
                    $('.is-localePopUp .is-close').focus();
                }

            }
        }

        //Sign in Modal
        var signInModalToggle = function () {
            $('.is-signInPopUp').toggleClass('h-hidden');
            $('.m-navbar_signInOverlay').toggleClass('h-hidden');
            if ($('.is-signInPopUp').hasClass('h-hidden')) {
                //close dropdown Sign In
                $('.is-signInToggle').focus();
                $('.is-header_madSI').children('.mad-barSI-arrow').removeClass('MMM--icn_up_arrow').addClass('MMM--icn_down_arrow');
                $('.is-header_madDesktopSI').children('.mad-barSI-arrow').removeClass('MMM--icn_up_arrow').addClass('MMM--icn_down_arrow');
                if ($('.is-header_madSI').hasClass('is-open')) {
                    $('.is-header_madSI').removeClass('is-open').addClass('is-closed');
                }
            } else {
                //open dropdown Sign In
                resetDesktopMenuOverlay();
                $('.is-signInPopUp a').first().focus();
                $('.is-header_madSI').children('.mad-barSI-arrow').removeClass('MMM--icn_down_arrow').addClass('MMM--icn_up_arrow');
                $('.is-header_madDesktopSI').children('.mad-barSI-arrow').removeClass('MMM--icn_down_arrow').addClass('MMM--icn_up_arrow');
                
                if ($('.is-header_madSI').hasClass('is-closed')) {
                    $('.is-header_madSI').removeClass('is-closed').addClass('is-open');
                }
            }
        }
        //END Sign in Modal

        //Profile in Modal
        var profileModalToggle = function () {
            $('.is-profilePopUp').toggleClass('h-hidden');
            $('.m-navbar_profileOverlay').toggleClass('h-hidden');
            if ($('.is-profilePopUp').hasClass('h-hidden')) {
                //closes
                $('.is-profileToggle').focus();
                $('.is-header_mad').children('.mad-bar-arrow').removeClass('MMM--icn_up_arrow').addClass('MMM--icn_down_arrow');
                $('.is-header_madDesktop').children('.mad-bar-arrow').removeClass('MMM--icn_up_arrow').addClass('MMM--icn_down_arrow');
                if ($('.is-header_mad').hasClass('is-open')) {
                    $('.is-header_mad').removeClass('is-open').addClass('is-closed');
                }
            } else {
                //opens
                resetDesktopMenuOverlay();
                $('.is-profilePopUp a').first().focus();
                $('.is-header_mad').children('.mad-bar-arrow').removeClass('MMM--icn_down_arrow').addClass('MMM--icn_up_arrow');
                $('.is-header_madDesktop').children('.mad-bar-arrow').removeClass('MMM--icn_down_arrow').addClass('MMM--icn_up_arrow');
                if ($('.is-header_mad').hasClass('is-closed')) {
                    $('.is-header_mad').removeClass('is-closed').addClass('is-open');
                }
                var userEmail = $('#uE').text();
                if (userEmail.length > 24) {
                    $('#uE').attr('alt', userEmail);
                    var truncated = userEmail.trim().substring(0, 24) + "…";
                    $('#uE').text(truncated);
                }
            }
        }
        //END Profile Modal

        // --------------- Accessibility -----------------

        var ariaToggle = function (e, attr) {
            e.attr(attr, e.attr(attr) === "true" ? "false" : "true");
        }

        var resetAriaAttr = function (e, attr) {
            e.attr(attr, "false");
        }

        var focusFirstDropdownItem = function (e) {
            e.find('a:first').focus();
        }

        function focusLoop(e) {
                if (e.keyCode === 9) {
                    if (e.shiftKey) {
                        if ($(document.activeElement)[0] === e.data.firstTabStop[0]) {
                            e.preventDefault();
                            e.data.lastTabStop.focus();
                        }
                    } else {
                        if ($(document.activeElement)[0] === e.data.lastTabStop[0]) {
                            e.preventDefault();
                            e.data.firstTabStop.focus();
                        }
                    }
                }

                // Close the window by pressing Esc-key 
                if (e.keyCode === 27 && e.data.escapeFunction !== null) {
                    e.data.escapeFunction();
                }
        }

        function createModalAccessibility(modalQuery, modalStart, modalFinish, screensize, escapeFunction) {
            var modal = $(modalQuery);
            var focusableElementsString = 'a[href]:not([disabled]), area[href], button:not([disabled]):not([type="hidden"]), input:not([disabled]):not([type="hidden"]), select:not([disabled]):not([type="hidden"]), textarea:not([disabled]):not([type="hidden"]), button:not([disabled]):not([type="hidden"]), iframe, object, embed, [tabindex="0"], [contenteditable]';
            var focusableElements = modal.find(focusableElementsString);
            focusableElements = Array.prototype.slice.call(focusableElements);
            var firstTabStop = focusableElements[0];
            if (modalStart !== '') {
                firstTabStop = $(modalStart);
            }
            var lastTabStop = focusableElements[focusableElements.length - 1]
            if (modalFinish !== '') {
                lastTabStop = $(modalFinish);
            }
            
            // Call focusLoop to create the modal loops
            if (($(window).width() < 960 && screensize == 'mobile tablet') ||
                ($(window).width() > 959 && screensize == 'desktop') ||
                ($(window).width() > 1 && screensize == 'all')) {
                    modal.off('keydown').on('keydown', {modal: modal, firstTabStop: firstTabStop, lastTabStop: lastTabStop, escapeFunction: escapeFunction}, focusLoop);
            }
        }

        function modalAccessibilityTrigger() {
            createModalAccessibility('.is-dropdown', '.is-header_menuLink', 'a.m-navbar_link:last', 'mobile tablet', openAndCloseDropdown);
            createModalAccessibility('.is-localePopUp', '.is-localePopUp .is-close', '.is-localePopUp .is-saveLocale', 'mobile tablet', localeModalToggle);
            createModalAccessibility('.is-localePopUp', '.is-localePopUp input[checked]', '.is-localePopUp button[type=submit]', 'desktop', localeModalToggle);
            createModalAccessibility('.is-profilePopUp', '.is-profilePopUp .is-close', '.is-profilePopUp a:last-child', 'mobile tablet', profileModalToggle);
            createModalAccessibility('.is-profilePopUp', '.is-profilePopUp a:first-child', '.is-profilePopUp a:last-child', 'desktop', profileModalToggle);
        }

        function ellipsisTrigger() {
             //Display just initial of Lastname & saving the full last name in data attribute.
            var userLastName = $('#fieldZone2Id').text();
            $('.fieldZone2').attr('alt', userLastName);
            var justInitial = userLastName.trim().substring(0, 1) + ".";
            $('.fieldZone2').text(justInitial);
        
            //Set width of name container to auto in case is not needed.
            if ($('#fieldZoneDropDown').text().length < 16) {
                //Short
                //alert("short name " + $('#fieldZoneDropDown').text());
                $(".fieldZone1").width('auto');
                $("#fieldZoneDropDown").width('auto');
            }else{
                //Long
                var longName = $('#fieldZoneDropDown').text().length * 8;
                if(longName >= 200){ //based on the length for mobile
                    longName = 200;
                }
                //alert("long name " + longName);
                $(".fieldZone1").width(longName);
            }
            $(".fieldZone1").css('display','inline-block');
            $(".fieldZone2").css('display','inline-block');

            //Sets the top of the container based on the presence of the class "wpthemeHeader"
            if ( $( ".wpthemeHeader" ).length != 1 ) {
                $( ".m-navbar_profilePopup.mad-menu-container" ).addClass("no-wpthemeHeader");
                $( ".m-navbar_profileOverlay" ).addClass("no-wpthemeHeaderOverlay");
            }
        }

        function expheadingAccessibilityTrigger () {
            // Footer accessibility for expandable headings
            $('.is-expandable').each(function () {
                var _self = $(this);

                // Mobile expandable heading states
                if ($(window).width() < 768) {
                    $(this).attr('tabindex', '0');

                    _self.on('click keydown', function (event) {
                        if (event.which == 1 || event.which == 13) { // verify that it was a click (1) or enter keydown (13) 
                            $(this).toggleClass('is-open');
                            $(this).attr('aria-expanded', $(this).hasClass('is-open') ? 'true' : 'false');
                            $(this).next().find('a').first().focus();
                        }
                    })
                } else {
                    // Remove expandable heading states if tablet or desktop
                    _self.attr('tabindex', '-1').removeAttr('aria-expanded').removeAttr('aria-controls').attr('role', 'none').off('click keydown');
                }
            });
        }

        return newGSN;

    });

}(MMMRequire));
